<template>
  <WdsText class="tw-text-right" size="sm">
    {{ column.currency }} {{ formattedRate }}
    <br />
    {{ rateTypeLabel }}
  </WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { textHelpers } from '@/utils/tools'
import { useTranslation } from '@/composables/translation'

const PaymentRequestRateColumnClient = graphql(`
  fragment PaymentRequestRateColumnClient on PaymentRequest {
    id
    currency
    hire {
      rate
      rateType
      hasMilestones
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof PaymentRequestRateColumnClient> }>()
const column = computed(() => useFragment(PaymentRequestRateColumnClient, props.row))
const { $t } = useTranslation()

const formattedRate = computed(() => {
  const rate = column.value.hire?.rate
  return rate ? rate.toLocaleString() : ''
})

const rateTypeLabel = computed(() => {
  if (column.value.hire?.hasMilestones) {
    return $t('milestone')
  }

  const type = column.value.hire?.rateType
  if (!type) return ''

  const read = textHelpers.keyToHumanReadable(type)
  if (read !== null && read.length > 0) {
    return textHelpers.capitalizeFirstLetter(read)
  }
  return read ?? ''
})
</script>

